import React, { Component } from 'react';

export default class AddMessage extends Component {

    state = {
        content: '哈'
    };
    componentDidMount(){
        console.log('componentDidMount')
    }
    componentWillReceiveProps(){
        console.log('componentWillReceiveProps')
    }

    render() {
        let { content } = this.state;
        return (
            <div>
                <a target="xiaoshenyang" class="menu_click_color">通用公开信息</a>
                <iframe name="xiaoshenyang" src="http://dev.im-dangdang.com/crm/openInfo" width="300" height="400"></iframe>
            </div>
        );
    }
}
